import { Platform } from '@angular/cdk/platform';
import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit  } from '@angular/core';
import { MatDialogRef, MatTabGroup, MAT_DIALOG_DATA } from '@angular/material';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import dayjs from 'dayjs';
import { DateFormat } from 'src/app/core/class/date-format';

interface IReportCriterionRow {
  code: string;
  name: string;
  inputType: string;
  order?: number;
  parentCode?: string;
  controlField?: any;
  displayOrder?: string;
  level?: number;
  rowType: 'header' | 'subheader' | 'criterion';
  expanded?: boolean;
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-view-properties-original-dialog-digital',
  styleUrls: ['./view-properties-original-dialog-digital.component.scss'],
  templateUrl: './view-properties-original-dialog-digital.component.html',
  providers: [
    // DateFormat,
    { provide: MAT_DATE_LOCALE, useValue: 'vi' },
    {
      provide: DateAdapter,
      useClass: DateFormat,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ViewPropertiesOriginalDialogDigitalComponent implements OnInit, AfterViewInit {
  listDataSource: any[] = [];
  listDataTable: IReportCriterionRow[] = [];
  listDataUpdateSource: any[] = [];
  customerMohaId: any = null
  customerMohaName: any = null
  listCustomer: any[] = [];
  listColumnVersionHistory: string[] = [];
  listDataVersionHistory: any[] = [];
  optionsMap = new Map<number, any[]>();
  displayedColumns = ["stt", "nameCriteria", "infoTemplate"];
  headerColumns = ["groupHeader"];
  displayedHistoryColumns: string[] = []
  isOriginalContract: boolean = false;
  titleChange: string = '';
  hideCriteriaUpdateHistory: boolean = false;
  @ViewChild('myTabGroup', { static: false }) myTabGroup: MatTabGroup;
  @ViewChild('inputName', { static: false }) inputName: ElementRef;
  isInforTab = 0
  fieldMap = new Map<string, any>()
  private readonly expandedGroups = new Map<string, boolean>();
  private readonly parentCodeMap = new Map<string, string>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewPropertiesOriginalDialogDigitalComponent>,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
    this.listDataUpdateSource = this.data.listDataUpdateSource
    this.listDataSource = this.data.listDataSource
    this.rebuildTableRows()
    this.customerMohaId = this.data.customerMohaId
    this.customerMohaName = this.data.customerMohaName
    this.listCustomer = this.data.listCustomer
    this.optionsMap = this.data.optionsMap
    this.isOriginalContract = this.data.isOriginalContract;
    this.titleChange = this.data.titleChange;
    this.hideCriteriaUpdateHistory = !!this.data.hideCriteriaUpdateHistory;
    this.listDataVersionHistory = this.data.listDataVersionHistory;
    this.buildColumns(this.data.listColumnVersionHistory)
    this.initFieldMap(this.data.listColumnVersionHistory)
  }

  ngAfterViewInit() {
    this.dialogRef.afterOpened().subscribe(() => {
      setTimeout(() => {
        const activeEl = document.activeElement as HTMLElement;
        activeEl.blur();
      });
    });
  }


  initFieldMap(dataStandard: any[]) {
    dataStandard.forEach(f => {
      this.fieldMap.set(f.code, f)
    })
  }

  getField(code: string) {
    return this.fieldMap.get(code)
  }


  buildColumns(dataStandard: any[]) {
    this.displayedHistoryColumns = dataStandard
      .filter(x => x.code)
      .map(x => x.code)
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getFormatDate(date: string) {
    return dayjs(date).format('DD/MM/YYYY')
  }

  getDataDropdown(data: any, value: string) {
    const listMetadata = JSON.parse(data.metadata);
    let valueView = listMetadata.find(e => e.value == value || e.value == value.toString());
    return valueView ? valueView.name : '';
  }

  private rebuildTableRows() {
    const nodes: IReportCriterionRow[] = (this.listDataSource || [])
      .filter((item: IReportCriterionRow) => !!item && !!item.code)
      .map((item: IReportCriterionRow) => ({
        ...item,
        expanded: item.inputType === 'HEADER'
          ? (this.expandedGroups.has(item.code) ? this.expandedGroups.get(item.code) : true)
          : undefined,
        rowType: item.inputType === 'HEADER' ? 'header' : 'criterion'
      }));

    const childrenMap = new Map<string, IReportCriterionRow[]>();
    this.parentCodeMap.clear();
    nodes.forEach(node => {
      const parentCode = node.parentCode || '';
      this.parentCodeMap.set(node.code, parentCode);
      const children = childrenMap.get(parentCode) || [];
      children.push(node);
      childrenMap.set(parentCode, children);
    });

    const effectiveOrder = (node: IReportCriterionRow): number => {
      const children = childrenMap.get(node.code) || [];
      return node.inputType === 'HEADER' && children.length
        ? Math.min(...children.map(effectiveOrder))
        : Number(node.order || 0);
    };
    childrenMap.forEach(children =>
      children.sort((first, second) => effectiveOrder(first) - effectiveOrder(second))
    );

    const rows: IReportCriterionRow[] = [];
    let runningOrder = 0;
    const appendNode = (node: IReportCriterionRow, displayOrder: string, level: number) => {
      const isHeader = node.inputType === 'HEADER';
      rows.push({
        ...node,
        displayOrder,
        level,
        rowType: isHeader ? 'subheader' : 'criterion'
      });
      if (isHeader) {
        (childrenMap.get(node.code) || []).forEach((child, index) =>
          appendNode(child, `${displayOrder}.${index + 1}`, level + 1)
        );
      }
    };

    const rootNodes = childrenMap.get('') || [];
    const rootHeaders = rootNodes.filter(node => node.inputType === 'HEADER');
    if (!rootHeaders.length) {
      rootNodes.forEach(node => {
        runningOrder++;
        appendNode(node, `${runningOrder}`, 1);
      });
    } else {
      rootHeaders.forEach(root => {
        rows.push({ ...root, displayOrder: null, level: 0, rowType: 'header' });
        (childrenMap.get(root.code) || []).forEach(child => {
          runningOrder++;
          appendNode(child, `${runningOrder}`, 1);
        });
      });
    }
    this.listDataTable = rows;
  }

  toggleGroup(row: IReportCriterionRow) {
    row.expanded = !row.expanded;
    this.expandedGroups.set(row.code, row.expanded);
  }

  isRowVisible(row: IReportCriterionRow): boolean {
    let parentCode = row.parentCode || '';
    while (parentCode) {
      if (this.expandedGroups.get(parentCode) === false) return false;
      parentCode = this.parentCodeMap.get(parentCode) || '';
    }
    return true;
  }

  trackByCode(_: number, row: IReportCriterionRow): string {
    return row.code;
  }

  isHeaderRow = (_: number, row: IReportCriterionRow) => row.rowType === 'header';
  isCriterionRow = (_: number, row: IReportCriterionRow) => row.rowType !== 'header';

  getDisplayValue(element: any): string {
    const value = element && element.controlField ? element.controlField.value : null;
    if (value === null || value === undefined || value === '') return '';
    if (element.inputType === 'DATETIME') return this.getFormatDate(value);
    if (element.inputType === 'DROPDOWN') {
      const options = this.optionsMap.get(element.id) || [];
      const selected = options.find(option => option.value == value);
      return selected ? selected.name : value;
    }
    return value;
  }
}
